import { render } from "./Skill.vue?vue&type=template&id=27c9092c"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"
script.render = render

export default script